module.exports = __webpack_public_path__ + "static/media/1717128339370-min.9d3d8be7.JPG";